import AccountLoading from './Loading';
export default AccountLoading;
